import Heading from '../components/Heading'
import Button from '../components/Button'
import React, { FormEvent, Fragment, useMemo } from 'react'
import Input from '../components/Input'
import Card from '../components/Card'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

type LoginData = {
    name: string
    password: string
}

const Login: React.FC = () => {
    const { login } = useAuth()
    const navigate = useNavigate()

    const [loginData, setLoginData] = React.useState<LoginData>({
        name: '',
        password: '',
    })

    const updateLoginData = (key: keyof LoginData, value: string) => {
        setLoginData((prevState) => ({
            ...prevState,
            [key]: value,
        }))
    }

    const [apiUrl, setApiUrl] = React.useState<string>(
        localStorage.getItem('zr_customizer_api_url') ?? ''
    )

    const wrapperUrl = useMemo(() => {
        const wrapper = document.getElementById('zr-customizer-wrapper')
        return wrapper && wrapper.dataset.api ? wrapper.dataset.api : null
    }, [])

    const { t } = useTranslation(['login'])

    const storeUrl = () => {
        if (apiUrl && apiUrl.length > 0) {
            localStorage.setItem('zr_customizer_api_url', apiUrl)
            window.location.reload()
        }
    }

    const isValid = useMemo(() => {
        try {
            yup.object({
                name: yup.string().required().min(3),
                password: yup.string().required().min(3),
            }).validateSync(loginData)
            return true
        } catch {
            return false
        }
    }, [loginData])

    const onSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        login(loginData.name, loginData.password)
        navigate('/')
    }

    return (
        <form onSubmit={onSubmit}>
            <Heading level={2} classes={'zr-mb-4'}>
                {t('heading')}
            </Heading>
            <Card classes={'zr-mb-4'}>
                {!wrapperUrl && (
                    <Fragment>
                        <Heading level={4} classes={'zr-mb-4'}>
                            {t('api_wrapper.title')}
                        </Heading>
                        <Input
                            type={'text'}
                            placeholder={t('api_wrapper.api_url')}
                            property={'api'}
                            value={apiUrl}
                            onChange={(_, value) => setApiUrl(value)}
                            classes={'zr-mb-4 zr-mr-4'}
                        />
                        <Button
                            fn={() => storeUrl()}
                            hierarchy={'primary'}
                            text={t('api_wrapper.save')}
                        />
                    </Fragment>
                )}
                <Heading level={4} classes={'zr-my-4'}>
                    {t('login_wrapper.title')}
                </Heading>
                <Input
                    type={'text'}
                    placeholder={t('login_wrapper.username')}
                    property={'name'}
                    value={loginData.name ?? ''}
                    onChange={(_, value) => updateLoginData('name', value)}
                    classes={'zr-mb-6 zr-mr-4'}
                />
                <Input
                    type={'password'}
                    placeholder={t('login_wrapper.password')}
                    property={'password'}
                    value={loginData.password ?? ''}
                    onChange={(_, value) => updateLoginData('password', value)}
                    classes={'zr-mb-4 zr-mr-4'}
                />
                <Button
                    disabled={!isValid}
                    type={'submit'}
                    hierarchy={'primary'}
                    text={t('login_wrapper.login')}
                />
            </Card>
        </form>
    )
}

export default Login
